import { c as _c } from "react/compiler-runtime";
import Box from '@classify/react-core-components/Box';
import type { Props as BoxProps } from '@classify/react-core-components/Box';
import PersonIcon from '@mui/icons-material/Person';
interface Props extends BoxProps {
  isSmaller?: boolean;
}
export default function VisitorAvatar(t0) {
  const $ = _c(9);
  let isSmaller;
  let otherProps;
  if ($[0] !== t0) {
    ({
      isSmaller,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = isSmaller;
    $[2] = otherProps;
  } else {
    isSmaller = $[1];
    otherProps = $[2];
  }
  const size = isSmaller ? 32 : 40;
  let t1;
  if ($[3] !== size) {
    t1 = {
      width: size,
      height: size,
      backgroundColor: "content.highlight.firstLevel.background",
      borderRadius: "50%",
      display: "grid",
      alignItems: "center",
      justifyItems: "center",
      color: "text.primary"
    };
    $[3] = size;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <PersonIcon />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== otherProps || $[7] !== t1) {
    t3 = <Box sx={t1} {...otherProps}>{t2}</Box>;
    $[6] = otherProps;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}